import React from "react";

const styles = {
  leanSection: {
    maxWidth: 1100,
    margin: "32px auto",
    padding: "0 1.5rem",
    textAlign: "center"
  },
  sectionTitle: {
    margin: 0,
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "white"
  },
  sectionSubhead: {
    marginTop: 8,
    color: "white",
    maxWidth: 760,
    lineHeight: 1.6,
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  contactCard: {
    marginTop: 24,
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 20,
    padding: "2rem 2.5rem",
    background: "rgba(255,255,255,0.04)",
    maxWidth: 480,
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "0.35rem"
  },
  cardText: {
    color: "#B0B6C7",
    lineHeight: 1.6
  },
  linkButton: {
    color: "#B86FFF",
    textDecoration: "none",
    fontWeight: 600
  },
  ctaButton: {
    marginTop: 20,
    border: "none",
    borderRadius: 999,
    padding: "14px 28px",
    fontSize: 15,
    fontWeight: 600,
    color: "white",
    background: "linear-gradient(120deg, #FF6661, #B86FFF, #4D44DC)",
    cursor: "pointer",
    letterSpacing: "0.2em"
  }
};

const ContactPage = () => (
  <section style={styles.leanSection}>
    <h2 style={styles.sectionTitle}>Contact Us</h2>
    <p style={styles.sectionSubhead}>Ready to activate a TwoDots room for your brand, team, or experience?</p>
    <div style={styles.contactCard}>
      <p style={styles.cardText}>
        Email: <a href="mailto:twodotsai@gmail.com" style={styles.linkButton}>twodotsai@gmail.com</a>
      </p>
      <p style={styles.cardText}>
        Site: <a href="https://www.twodots.cloud" style={styles.linkButton}>www.twodots.cloud</a>
      </p>
     
      <button type="button" style={styles.ctaButton}>Schedule a demo</button>
    </div>
  </section>
);

export default ContactPage;
